import Card from 'app/shared-components/Card'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import useTableStyles from 'app/tss/table.styles'
import useCardForTableStyles from 'app/tss/cardForTable'
import requestConfig from 'app/requests/ServiceCenter/ServiceCenter.requests'
import useLabel from 'app/hooks/useLabel'

import tableConfig from './inboundOrders.config'

const InboundOrders = ({
    serviceCenterId,
}: Readonly<{ serviceCenterId: number }>) => {
    const l = useLabel()
    const {
        classes: cardClasses,
    } = useCardForTableStyles()
    const {
        classes: tableClasses,
    } = useTableStyles()

    return (
        <Card
            title={l('INBOUND_ORDERS')}
            className={cardClasses.root}
        >
            <SkyNetTable
                name="InboundOrders"
                tableConfig={tableConfig}
                customUrl={requestConfig.inboundOrders({
                    serviceCenterId,
                }).url}
                simple
                className={tableClasses.table}
            />
        </Card>
    )
}

export default InboundOrders
